/* The Wandr light arc — sunrise → golden hour → dusk, with a "now" dot. */

export function dayFraction(date = new Date()) {
  const mins = date.getHours() * 60 + date.getMinutes();
  const start = 6 * 60; // arc window 06:00 → 20:00
  const end = 20 * 60;
  return Math.min(1, Math.max(0, (mins - start) / (end - start)));
}

export const LightArc = ({ fraction, className = "", dotBorder = "var(--paper)" }) => (
  <div className={`relative ${className}`} aria-hidden="true" data-testid="light-arc">
    <div className="h-[2px] rounded-full" style={{ background: "var(--light-arc)" }} />
    <span
      className="absolute -top-[4px] w-2.5 h-2.5 rounded-full bg-ember"
      style={{ left: `${fraction * 100}%`, transform: "translateX(-50%)", border: `2px solid ${dotBorder}` }}
    />
  </div>
);
